import { useState, useEffect } from 'react';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { HiOutlineMail } from 'react-icons/hi';
import { BiLockAlt } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Spinner } from "reactstrap"
import { userLogin, reset } from '../../Redux/Actions/actions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from '@material-ui/core';
import CryptoJS from 'crypto-js';

const Login = () => {

  const dispatch = useDispatch();
  const loading = useSelector((state: RootStateOrAny) => state?.user?.loading);
  const authenticated = useSelector((state: RootStateOrAny) => state?.user?.data);
  const errorInfo = useSelector((state: RootStateOrAny) => state?.user?.errorInfo);
  const userToken = useSelector((state: RootStateOrAny) => state?.token?.userToken);
  const expiredloanHistory = useSelector((state: RootStateOrAny) => state?.loanHistory?.loanHistoryDetails);
  const [userInfo, setUserInfo] = useState<any>({
    username: '',
    password: '',
  });

  const onChange = (e: any) => {
    setUserInfo({
      ...userInfo,
      [e.target.name]: e.target.value
    })
  };

  expiredloanHistory ==='{}' && toast.error('session expired sign in again')

  const isInvalid = userInfo.name === '' || userInfo.password === '';

  const notify = () => toast.error(errorInfo);

  userToken?.userName && (window.location.href = ('/dashboard'));

  const appkey = "5656565656565656";

const encrypt10 = (appstring) => {
 const plaintext = CryptoJS.enc.Utf8.parse(appstring);
  let secSpec = CryptoJS.enc.Utf8.parse(appkey);    
  let ivSpec = CryptoJS.enc.Utf8.parse(appkey);
 secSpec = CryptoJS.lib.WordArray.create(secSpec.words.slice(0, 16/4));
  ivSpec = CryptoJS.lib.WordArray.create(ivSpec.words.slice(0, 16/4));

  const encrypted = CryptoJS.AES.encrypt(plaintext, secSpec, {iv: ivSpec});
  return encrypted.toString()
}

  useEffect(() =>{
    if(authenticated === '{}'){
      notify();
        dispatch(reset())
    }else if(authenticated?.isSuccess){
      window.location.href = ("/mtoken")
    }
  }, [authenticated])

  const Linkmtoken = (e:any) => {
    e.preventDefault();
    localStorage.clear();
    localStorage.setItem("username", userInfo.username );
    userInfo.password = userInfo?.password
    dispatch(userLogin(userInfo));
  }

  return (
    <section style={{
      backgroundImage: `url("../img/login-bg.jpg")`
    }} className="bg-login-bkimg">

      <div style={{ right: `10%` }} className="row p-absolute-resp p-3">
        <ToastContainer
          position="top-center"
          autoClose={2000}
        />
        <div className="col-lg-11">
          <div className="card bg-transparent bd-transparent border-0 mb-0">
            <div className="card-body py-0">
              <Link to="/"><img className="logo" alt="logo" src="/img/sterling-logo.svg" /></Link>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid p-0">
        <div className="row min-vh-100 rowreversed-resp login-card">
          <div className="col-lg-1 d-md-block d-none my-auto mx-auto p-0 m-0">

          </div>
          <div className="col-lg-4 my-auto mx-auto">
            <div className="card bg-pale-b border-0 shadow shadow-showcase b-r-5">
              <div className="card-body p-5">
                <div className="mb-4">
                  <h3>Login</h3>
                  <p>Welcome Back</p>
                </div>
              <form data-testid="form" aria-label='form' onSubmit={Linkmtoken}>
                <div className="form-group">
                  <label>Username</label>
                  <div className="input-group"><span className="input-group-text"><HiOutlineMail /></span>
                    <input data-testid="username" aria-label='Username' onChange={onChange} required className="form-control" type="text" placeholder="Enter username" name='username'/>
                  </div>
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <div className="input-group"><span className="input-group-text"><BiLockAlt /></span>
                    <input data-testid="password" aria-label='Password' onChange={onChange} required className="form-control" type="password" name="password" placeholder="*********" />
                  </div>
                </div>

                <div className="form-group mt-5">
                  {/* <button disabled={isInvalid} onClick={Linkmtoken} className="btn btn-primary btn-lg btn-block w-100 py-2" type="submit"></button> */}
                  <button disabled={isInvalid} className="btn btn-primary btn-lg btn-block w-100 py-2" type="submit">
                    {loading ? <Spinner /> : 'Login'}</button>
                </div>
                </form>
                <div className='d-flex justify-content-center'>
                  <Button color='primary' type='button' component={Link} to='adminLogin'>Sign in as admin</Button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-7 my-auto mx-auto py-5">
            <div className="card bg-transparent bd-transparent border-0">
              <div className="card-body">
                <h1 className="text-white mb-3">HCM Loan Application Portal</h1>
                <h4 className="text-white font-light f-w-400">Accessing loans with ease</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
